<template>
    <span class="likeBtn">
        <a v-if="isLoading" href="#"><icon icon="sync" spin :size="size" /></a>
        <a v-else-if="wasLiked" href="#" class="active" @click.prevent="like"><icon icon="heart" :size="size" /></a>
        <a v-else href="#" @click.prevent="like"><icon icon="heart" :size="size" /></a>
    </span>
</template>

<script>

    import Icon from '../../ui/Icon';

    export default {
        name: 'LikePostButton',
        props: {
            post: {default: Object},
            size: {type: String, default: '1x'},
        },
        data() {
            return {
                isLoading: false,
                wasLiked: false
            }
        },

        computed:{
            isLoggedIn(){
                return this.$store.getters['user/isLoggedIn'];
            }
        },
        mounted(){
            if(this.post.wasLiked) this.wasLiked = this.post.wasLiked;
        },
        methods: {
            like(){
                if(!this.isLoggedIn){
                    this.$bus.$emit('error', 'Please login for liking posts!');
                    return;
                }

                this.isLoading = true;

                if(this.wasLiked){
                  this.$api.unLikePost(this.post)
                    .then((res)=> {
                      this.isLoading = false;
                      this.wasLiked = false;
                      this.$bus.$emit('success', res.data.message);
                      this.$bus.$emit('post.unliked', this.post);
                    })
                    .catch((err)=>{
                      this.isLoading = false;
                    });
                } else {
                  this.$api.likePost(this.post)
                    .then((res)=> {
                      this.isLoading = false;
                      this.wasLiked = true;
                      this.$bus.$emit('success', res.data.message);
                    })
                    .catch((err)=>{
                      this.isLoading = false;
                    });
                }



            }
        },
        components:{
            Icon
        }
    }
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/vars.scss"

    a.active .fa-icon
        color: $colorPrimary


</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/LikePostButton.vue